// src/components/GenericState.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './GenericState.css'; // You can reuse Illinois.css

const GenericState = () => {
  const { stateName } = useParams(); // Get state from URL
  const stateFormatted = stateName.replace(/-/g, ' ').toUpperCase(); // e.g., illinois -> ILLINOIS

  const [activeFaq, setActiveFaq] = useState(null);
  const [formData, setFormData] = useState({
    fullName: '',
    practiceName: '',
    email: '',
    phone: '',
    specialty: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const response = await fetch('https://formspree.io/f/xrejwqgl', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ ...formData, state: stateFormatted })
      });

      if (response.ok) {
        setSubmitStatus({ type: 'success', message: `Thank you! We will contact you shortly about our services in ${stateFormatted}.` });
        setFormData({ fullName: '', practiceName: '', email: '', phone: '', specialty: '', message: '' });
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Something went wrong. Please try again or call us directly.' });
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus({ type: '', message: '' }), 5000);
    }
  };

  // Generic services
  const servicesList = [
    `MEDICAL CODING SERVICES IN ${stateFormatted}!`,
    `CREDENTIALING SERVICES IN ${stateFormatted}!`,
    `ACCOUNT RECEIVABLE SERVICES IN ${stateFormatted}!`,
    `ELIGIBILITY VERIFICATION SERVICES IN ${stateFormatted}!`,
    `PATIENT BILLING SERVICES IN ${stateFormatted}!`,
    `OUT OF NETWORK NEGOTIATION SERVICES IN ${stateFormatted}!`,
    `CLEAN-UP MEDICAL BILLING AUDIT SERVICES`,
    `PRIOR AND RETRO AUTHORIZATION SERVICES`
  ];

  const faqs = [
    { q: `What are the top medical billing services in ${stateFormatted}?`, a: `We provide comprehensive medical billing services in ${stateFormatted} including coding, credentialing, AR recovery, eligibility verification, patient billing, out of network negotiation, billing audits, and authorization services.` },
    { q: `Do you offer physician credentialing services in ${stateFormatted}?`, a: `Yes, we offer complete physician credentialing services in ${stateFormatted} including CAQH credentialing, payer enrollment services, and provider enrollment services.` }
    // Add more generic FAQs if needed
  ];

  return (
    <main className="illinois-page"> {/* You can reuse Illinois styles */}
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <div className="container">
          <span className="breadcrumb-item">Home</span>
          <span className="breadcrumb-separator">→</span>
          <span className="breadcrumb-item">States We Serve</span>
          <span className="breadcrumb-separator">→</span>
          <span className="breadcrumb-item active">{stateFormatted}</span>
        </div>
      </div>

      {/* Hero Section */}
      <section className="illinois-hero">
        <div className="container">
          <div className="illinois-hero-content">
            <h1 className="illinois-hero-title">
              Medical Billing Services <span className="highlight">in {stateFormatted}!</span>
            </h1>
            <p className="illinois-hero-description">
              At Providers Care Billing LLC, we deliver comprehensive medical billing services in {stateFormatted}, including major cities and surrounding areas. Our services cover billing, coding, AR recovery, and medical credentialing services for physicians, therapists, mental health providers, and group practices.
            </p>
            <button className="hero-talk-btn">TALK TO OUR BILLING EXPERT →</button>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="illinois-services">
        <div className="container">
          <h2 className="services-main-title">Medical Billing Services We Offer in {stateFormatted}!</h2>

          {servicesList.map((service, index) => (
            <div className="service-detail-block" key={index}>
              <h3 className="service-detail-title">{service}</h3>
              <p className="service-detail-text">Our expert team provides top-notch {service.toLowerCase()} to maximize your practice revenue and compliance.</p>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="illinois-faq">
        <div className="container">
          <h2 className="faq-main-title">Frequently Asked Questions</h2>
          <div className="faq-grid-illinois">
            {faqs.map((faq, index) => (
              <div className={`faq-item-illinois ${activeFaq === index ? 'active' : ''}`} key={index}>
                <div className="faq-question-illinois" onClick={() => toggleFaq(index)}>
                  <span>{faq.q}</span>
                  <button className="faq-toggle-illinois">{activeFaq === index ? '−' : '+'}</button>
                </div>
                <div className="faq-answer-illinois">
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Consultation Form */}
      <section className="illinois-consultation" id="consultation-form">
        <div className="container">
          <h2 className="consultation-title">Request a Free Consultation</h2>
          {submitStatus.message && (
            <div className={`form-status ${submitStatus.type}`}>
              {submitStatus.message}
            </div>
          )}
          <form onSubmit={handleSubmit} className="consultation-form-illinois">
            {/* same form as Illinois */}
          </form>
        </div>
      </section>
    </main>
  );
};

export default GenericState;